<template>
  <div class="sf-tab sf-tab-full sf-poiner rs-filters-list">
    <div v-for="filter in sortedFilters" :key="filter.name">
      <div
        v-if="shouldShow(filter)"
        v-tooltip="tooltip(filter)"
        :data-filter-type="filter.type"
        data-heap="insights-filter-item"
        class="sf-tab-item sf-hover sf-pointer sf-pad-v-1 sf-pad-h-1"
        :class="tooltip(filter) && 'sf-dim-el'"
        @click="edit(filter)"
      >
        <div class="sf-level sf-level-between">
          <span>{{ filter.name }}</span
          ><span
            class="
              fa fa-plus
              sf-c-text-light sf-pad-h-1 sf-hover-item sf-dim-el-hover
            "
          ></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import sortBy from 'lodash/sortBy'
import { filterTitle } from '../../utils/filter-texts'
import { filters as filterTypes } from '@app/insights/constants'

export default {
  props: {
    filters: {
      type: Array,
      required: true,
    },

    editFilter: {
      type: Function,
      required: true,
    },
  },

  computed: {
    ...mapState({
      submissionData: (state) => state.submissions.submissionData,
    }),
    sortedFilters() {
      const filtersWithName = this.filters.map((filter) => {
        return {
          ...filter,
          name: filter.name_key ? filterTitle(filter.name_key) : filter.name,
        }
      })

      return sortBy(filtersWithName, 'name')
    },
  },

  methods: {
    edit(filter) {
      if (!this.filterDisabled(filter)) this.editFilter(filter)
    },

    tooltip(filter) {
      if (this.filterDisabled(filter))
        return I18n.t('companies_overview.filters.feature_flag_disabled')
    },

    filterDisabled(filter) {
      return filter.disabledOnFirmLevel && filter.disabledOnFirmLevel()
    },

    shouldShow(filter) {
      if (filter.shouldShow) {
        return filter.shouldShow()
      }

      return !!(
        filter.type !== filterTypes.SUBMISSION_DATA ||
        (this.submissionData &&
          this.submissionData.submission_types &&
          this.submissionData.submission_types.length > 0)
      )
    },
  },
}
</script>
